import PropTypes from 'prop-types';
import React from 'react';
import Tag from '../../Elements/Tag/Tag';
import InputField from '../InputField/InputField';

import './LocationInput.scss';

export default class LocationInput extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            coordinates: {
                lat: null,
                lng: null,
            },
            value: props.value,
            name: props.value,
            remote: false,
            addressComponents: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.inputNameHash = Math.random().toString(36).substring(2, 15);
    }

    static propTypes = {
        /**
         * onChange handler
         */
        onChange: PropTypes.func,
        /**
         * onChange handler
         */
        onKeyPress: PropTypes.func,
        /**
         * Placeholder for the input field
         */
        placeholder: PropTypes.string,
        /**
         * the types field for the google places autocomplete variable. (i.e. ['(regions)'])
         */
        googlePlaceAPITypes: PropTypes.array,
        /**
         * any restrictions for the google places api definiton (i.e. {country: "us"})
         */
        googlePlaceAPIComponentRestrictions: PropTypes.object,
        /**
         * default value of the input
         */
        onBlur: PropTypes.func,
        idValue: PropTypes.string,
        hasIcon: PropTypes.bool,
        icon: PropTypes.string,
        withTags: PropTypes.bool,
        selectedLocations: PropTypes.array,
        /**
         * name of input element, autofill would be trigger depends on the input name
         */
        inputName: PropTypes.string,
        hasError: PropTypes.bool,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        onChange: () => {},
        onKeyPress: () => {},
        placeholder: 'City and/or State',
        googlePlaceAPITypes: ['(regions)'],
        googlePlaceAPIComponentRestrictions: { country: [] },
        value: '',
        onBlur: () => {},
        hasIcon: true,
        icon: 'location',
        withTags: false,
        selectedLocations: [],
        disabled: false,
    };

    componentDidMount() {
        if (!window.google && !window._googleMapsStartedLoading) {
            window._googleMapsStartedLoading = true;
            this.loadGoogleScript();
        } else {
            this.setUpGoogle();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            const newState = { ...this.state, value: this.props.value };
            this.setState({ ...newState });
        }
    }

    loadGoogleScript = () => {
        let script = document.createElement('script');
        script.onload = function () {
            this.setUpGoogle();
        }.bind(this);
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBFts9V0cwwsvKe6JdP8VcD9FLuYp5iWxU&libraries=places`;
        document.head.appendChild(script);
    };

    setUpGoogle = () => {
        if (window.google && window.google.maps) {
            const element = this.props.id
                ? document.getElementById(this.props.id)
                : this.inputElement;
            let autocomplete = new google.maps.places.Autocomplete(element, {
                types: this.props.googlePlaceAPITypes,
                componentRestrictions: this.props
                    .googlePlaceAPIComponentRestrictions,
            });

            autocomplete.setFields([
                'address_components',
                'formatted_address',
                'geometry',
            ]);

            autocomplete.addListener(
                'place_changed',
                function () {
                    let place = autocomplete.getPlace();
                    let lat = place.geometry.location.lat();
                    let lng = place.geometry.location.lng();
                    let value = place.formatted_address;
                    this.setState({
                        coordinates: {
                            lat,
                            lng,
                        },
                        value: value,
                        name: value,
                        remote: false,
                        addressComponents: place.address_components,
                    });

                    if (this.props.canSelectMulti) {
                        this.handleMultiSelect(lat, lng, value, false);
                    } else {
                        this.sendInfoToSearch(lat, lng, value, false);
                    }
                }.bind(this)
            );
        }
    };

    handleChange = (location) => {
        this.setState({
            coordinates: {
                lat: null,
                lng: null,
            },
            value: location,
            remote: false,
        });
        let val = location;
        let stateLat = this.state.lat;
        let stateLng = this.state.lng;
        let formattedInputVal = val.toLowerCase();
        let remote =
            formattedInputVal.trim() === 'remote' &&
            stateLat == null &&
            stateLng == null;

        this.sendInfoToSearch(stateLat, stateLng, val, remote);
    };

    handleMultiSelect = (lat, lng, value, remote) => {
        const isLocationSelectedAlready = this.props.selectedLocations.some(
            (location) => location.value === value || location.name === value
        );

        if (!isLocationSelectedAlready) {
            this.props.onChange([
                ...this.props.selectedLocations,
                {
                    coordinates: {
                        lat: lat,
                        lng: lng,
                    },
                    value: value,
                },
            ]);
        }

        /*clear input on select*/

        this.setState({
            coordinates: {
                lat: null,
                lng: null,
            },
            value: '',
            remote: null,
            addressComponents: null,
        });
    };

    sendInfoToSearch = (lat, lng, value, remote) => {
        let searchInfo = {
            coordinates: {
                lat: lat,
                lng: lng,
            },
            value: value,
            remote: remote,
            addressComponents: this.state.addressComponents,
        };

        if (!this.props.canSelectMulti) {
            this.props.onChange({ ...searchInfo, name: value, lat, lng });
        }
    };

    handleRemove = (item) => {
        const newSelectedLocations = this.props.selectedLocations.filter(
            (location) => {
                return location.value !== item.value;
            }
        );

        this.props.onChange(newSelectedLocations);
    };

    renderTag = (item, index) => (
        <Tag key={`item-${index}`} onRemove={() => this.handleRemove(item)}>
            {item.value}
        </Tag>
    );

    renderTags() {
        return (
            !!this.props.selectedLocations.length && (
                <div className="tags-container">
                    {this.props.selectedLocations.map(this.renderTag)}
                </div>
            )
        );
    }

    render() {
        return (
            <div className="component-Input-LocationInput">
                <InputField
                    idValue={this.props.idValue}
                    handleInput={(el) => (this.inputElement = el)}
                    name={this.props.inputName || this.inputNameHash}
                    type="text"
                    placeholder={this.props.placeholder}
                    inputValue={this.state.value}
                    onBlur={this.props.onBlur}
                    onChange={this.handleChange}
                    onKeyPress={this.props.onKeyPress}
                    classname={this.props.className}
                    icon={this.props.hasIcon ? this.props.icon : null}
                    hasError={this.props.hasError}
                    disabled={this.props.disabled}
                    qaDataAttr={'locationInput'}
                />

                {this.props.withTags && this.renderTags()}
            </div>
        );
    }
}
